import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, Grid} from '@material-ui/core';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
    container: {
        padding: theme.spacing(3,2)
    },
    circle: {
        height: "20px",
        width: "20px",
        borderRadius: '60%',
        display: 'inline-block',
        marginRight: "9px"
    },
    flex:{
        flexDirection: 'column',
        alignItems: "flex-start"  
    },
    displayFlex:{
        display: 'flex',
        padding: '3px'
    },
    yellow: {
        background: "#ffbf00"
    },
    green: {
        background: "#22bb45"
    },
    purple: {
        background: "#9d07e8"
    },
    blue: {
        background: "#64b5f6"
    },
    gray: {
        background: "#D6D7D8"
    },
    rose: {
        background: "#FC8EAC"
    },
    darkRed: {
        background: '#8b0000'
    }

}));

const LegendComponent = () => {
    const { circle, flex, displayFlex, yellow, green, purple, blue, gray, darkRed, rose } = useStyles();

	return (
        <Grid className={flex}>
            <Grid item className={displayFlex}>
                <div className={clsx(circle, yellow)}></div>
                    Rezervisan termin
            </Grid>
            <Grid className={displayFlex}>
                <div className={clsx(circle, purple)}></div>
                    Online termin
            </Grid>
            <Grid className={displayFlex}>
                <div className={clsx(circle, darkRed)}></div>
                    Odsutan
            </Grid>
            <Grid item className={displayFlex}>
                <div className={clsx(circle, rose)}></div>
                Vestačenje
            </Grid>
            <Grid item className={displayFlex}>
                <div className={clsx(circle, green)}></div>
                    Plaćen termin
            </Grid>
            <Grid item className={displayFlex}>
                <div className={clsx(circle, blue)}></div>
                    Regularan termin
            </Grid>
            <Grid item className={displayFlex}>
                <div className={clsx(circle, gray)}></div>
                    Klijent nije bio prisutan
            </Grid>
        </Grid>
	);
}

LegendComponent.propTypes = {
    name: PropTypes.string,
    label: PropTypes.string
}

export default LegendComponent;
